var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDocs = function SvgIconDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    d: "M7.987 19.872h8.03c1.62 0 2.457-.851 2.457-2.479v-6.742h-5.65c-.942 0-1.394-.452-1.394-1.394v-5.71H7.987c-1.612 0-2.456.851-2.456 2.486v11.36c0 1.628.844 2.479 2.456 2.479m4.98-10.32h5.431c-.045-.347-.293-.671-.685-1.07l-4.12-4.174c-.378-.384-.717-.64-1.063-.686v5.492q.008.439.437.437M9.08 13.987c-.324 0-.558-.233-.558-.535 0-.3.234-.534.558-.534h5.868c.309 0 .55.233.55.534a.536.536 0 0 1-.55.535zm0 2.825c-.324 0-.558-.233-.558-.534s.234-.535.558-.535h5.868c.309 0 .55.233.55.535a.536.536 0 0 1-.55.534z"
  })));
};
export default SvgIconDocs;